module.exports = __webpack_public_path__ + "media/images/dummy_item11-8c37b3921f49896df7df8921b6bc8622.jpg";